import React, { createContext, useContext, useMemo, useState } from "react";
import {
  ResearchTaskSchema,
  ResearchTaskStatus,
} from "../models/schema/ResearchTask";
import { PersonExtendedWIthTags } from "../models/schema/UpdatePersonResponse";

type ResearchTaskDictionary = Map<string, ResearchTaskSchema>;

interface ResearchTaskContextType {
  tasksMap: ResearchTaskDictionary;
  getAllTasks: () => ResearchTaskSchema[];
  getTaskById: (taskId: string) => ResearchTaskSchema;
  setTask: (task: ResearchTaskSchema) => void; // create or replace
  updateTask: (taskId: string, updated_task: ResearchTaskSchema) => void;
  deleteTask: (taskId: string) => void;
  clearAll: () => void;
}

const ResearchTaskContext = createContext<ResearchTaskContextType | undefined>(
  undefined,
);

// const taskResult1: PersonExtendedWIthTags = {
//   person: {
//     id: "1",
//     type: "person",
//     attributes: {
//       id: "1",
//       first_name: "John",
//       last_name: "Doe",
//       middle_name: null,
//       full_name: "John Doe",
//       email: "john.doe@example.com",
//       email_opt_in: false,
//       phone_number: null,
//       mobile_number: null,
//       mobile_opt_in: false,
//       work_phone_number: null,
//       fax_number: null,
//       born_at: null,
//       sex: null,
//       ethnicity: null,
//       marital_status: null,
//       religion: null,
//       language: null,
//       locale: null,
//       prefix: null,
//       suffix: null,
//       legal_name: null,
//       username: null,
//       employer: null,
//       occupation: null,
//       do_not_call: false,
//       do_not_contact: false,
//       federal_donotcall: false,
//       unsubscribed_at: null,
//       city_district: null,
//       county_district: null,
//       federal_district: null,
//       fire_district: null,
//       judicial_district: null,
//       labour_region: null,
//       precinct_id: null,
//       school_district: null,
//       school_sub_district: null,
//       state_lower_district: null,
//       state_upper_district: null,
//       supranational_district: null,
//       village_district: null,
//       city_sub_district: null,
//       ward: null,
//       township: null,
//       party: null,
//       previous_party: null,
//       party_member: null,
//       inferred_party: null,
//       support_level: null,
//       inferred_support_level: null,
//       support_level_changed_at: null,
//       support_probability_score: 0,
//       turnout_probability_score: 0,
//       is_volunteer: false,
//       is_supporter: false,
//       is_donor: false,
//       is_fundraiser: false,
//       is_prospect: false,
//       is_deceased: false,
//       is_cpu: false,
//       is_mobile_bad: false,
//       is_possible_duplicate: false,
//       is_profile_private: false,
//       is_profile_searchable: true,
//       is_survey_question_private: false,
//       is_ignore_donation_limits: false,
//       is_leaderboardable: false,
//       email1: "john.doe@example.com",
//       email1_is_bad: false,
//       email1_is_bouncing: false,
//       email2: null,
//       email2_is_bad: false,
//       email2_is_bouncing: false,
//       email3: null,
//       email3_is_bad: false,
//       email3_is_bouncing: false,
//       email4: null,
//       email4_is_bad: false,
//       email4_is_bouncing: false,
//       primary_email_id: 0,
//       capital_amount_in_cents: 0,
//       received_capital_amount_in_cents: 0,
//       spent_capital_amount_in_cents: 0,
//       donations_amount_in_cents: 0,
//       donations_amount_this_cycle_in_cents: 0,
//       donations_count: 0,
//       donations_count_this_cycle: 0,
//       donations_pledged_amount_in_cents: 0,
//       donations_raised_amount_in_cents: 0,
//       donations_raised_amount_this_cycle_in_cents: 0,
//       donations_raised_count: 0,
//       donations_raised_count_this_cycle: 0,
//       donations_to_raise_amount_in_cents: 0,
//       invoices_amount_in_cents: null,
//       invoices_count: null,
//       closed_invoices_amount_in_cents: null,
//       closed_invoices_count: null,
//       outstanding_invoices_amount_in_cents: null,
//       outstanding_invoices_count: null,
//       overdue_invoices_count: null,
//       invoice_payments_amount_in_cents: null,
//       invoice_payments_referred_amount_in_cents: null,
//       first_supporter_at: null,
//       first_volunteer_at: null,
//       first_donated_at: null,
//       first_fundraised_at: null,
//       first_invoice_at: null,
//       first_prospect_at: null,
//       first_recruited_at: null,
//       last_donated_at: null,
//       last_fundraised_at: null,
//       last_invoice_at: null,
//       last_contacted_at: null,
//       last_contacted_by_id: null,
//       last_call_id: null,
//       last_rule_violation_at: null,
//       note: null,
//       note_updated_at: null,
//       profile_content: null,
//       profile_content_html: null,
//       profile_headline: null,
//       submitted_address: null,
//       availability: null,
//       demo: null,
//       church: null,
//       external_id: null,
//       civicrm_id: null,
//       datatrust_id: null,
//       dw_id: null,
//       ngp_id: null,
//       pf_strat_id: null,
//       rnc_id: null,
//       rnc_regid: null,
//       salesforce_id: null,
//       van_id: null,
//       county_file_id: null,
//       state_file_id: null,
//       import_id: null,
//       auto_import_id: null,
//       author_id: null,
//       parent_id: null,
//       recruiter_id: null,
//       signup_type: 0,
//       registered_at: null,
//       banned_at: null,
//       contact_status: null,
//       could_vote_status: null,
//       priority_level: null,
//       priority_level_changed_at: null,
//       active_customer_expires_at: null,
//       active_customer_started_at: null,
//       phone_number_normalized: null,
//       mobile_number_normalized: null,
//       phone_time: null,
//       rule_violations_count: 0,
//       warnings_count: 0,
//       custom_values: {
//         born: null,
//         custom_page: null,
//         position: null,
//         linkedin_url: null,
//         university: null,
//         major: null,
//         graduation_year: null,
//       },
//       updated_at: new Date().toISOString(),
//       created_at: new Date().toISOString(),
//     },
//   },
//   tags: [
//     {
//       tag_id: "1",
//       tag_name: "Tag 1",
//     },
//   ],
// };

// export const dummyResearchTask1: ResearchTaskSchema = {
//   id: "dummy-id1",
//   task_status: ResearchTaskStatus.RUNNING,
//   task_result: taskResult1,
//   created_at: new Date(),
//   updated_at: new Date(),
//   error: null,
// };

// export const dummyResearchTask2: ResearchTaskSchema = {
//   id: "dummy-id2",
//   task_status: ResearchTaskStatus.COMPLETED,
//   task_result: taskResult1,
//   created_at: new Date(),
//   updated_at: new Date(),
//   error: null,
// };

// export const dummyResearchTask3: ResearchTaskSchema = {
//     id: "dummy-id3",
//     task_status: ResearchTaskStatus.RUNNING,
//     task_result: taskResult1,
//     created_at: new Date(),
//     updated_at: new Date(),
//     error: null,
//   };

//   export const dummyResearchTask4: ResearchTaskSchema = {
//     id: "dummy-id4",
//     task_status: ResearchTaskStatus.RUNNING,
//     task_result: taskResult1,
//     created_at: new Date(),
//     updated_at: new Date(),
//     error: null,
//   };

//   export const dummyResearchTask5: ResearchTaskSchema = {
//     id: "dummy-id5",
//     task_status: ResearchTaskStatus.RUNNING,
//     task_result: taskResult1,
//     created_at: new Date(),
//     updated_at: new Date(),
//     error: null,
//   };

//   export const dummyResearchTask6: ResearchTaskSchema = {
//     id: "dummy-id6",
//     task_status: ResearchTaskStatus.RUNNING,
//     task_result: taskResult1,
//     created_at: new Date(),
//     updated_at: new Date(),
//     error: null,
//   };

// const dummyTasksMap: ResearchTaskDictionary = new Map([
//   [dummyResearchTask1.id, dummyResearchTask1],
//   [dummyResearchTask2.id, dummyResearchTask2],
//   [dummyResearchTask3.id, dummyResearchTask3],
//   [dummyResearchTask4.id, dummyResearchTask4],
//   [dummyResearchTask5.id, dummyResearchTask5],
//   // [dummyResearchTask6.id, dummyResearchTask6],
// ]);

export const ResearchTaskProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tasksMap, setTasksMap] = useState<ResearchTaskDictionary>(new Map());
  // const [tasksMap, setTasksMap] = useState<ResearchTaskDictionary>(dummyTasksMap);

  const getAllTasks = useMemo(() => {
    return () => Array.from(tasksMap.values());
  }, [tasksMap]);

  const getTaskById = (taskId: string) => {
    const task = tasksMap.get(taskId);
    if (!task) {
      throw new Error(`Task with id ${taskId} not found`);
    }
    return task;
  };

  const setTask = (task: ResearchTaskSchema) => {
    setTasksMap((prev) => {
      const newMap = new Map(prev);
      newMap.set(task.id, task);
      return newMap;
    });

    // setTasksMap((prev) => ({ ...prev, [task.id]: task }));
  };

  const updateTask = (taskId: string, updated_task: ResearchTaskSchema) => {
    setTasksMap((prev) => {
      const existing = prev.get(taskId);
      if (!existing) return prev;
      const merged: ResearchTaskSchema = {
        ...existing,
        ...updated_task,
        updated_at: updated_task.updated_at ?? new Date(),
      };
      const newMap = new Map(prev);
      newMap.set(taskId, merged);
      return newMap;
    });
  };

  const deleteTask = (taskId: string) => {
    setTasksMap((prev) => {
      const newMap = new Map(prev);
      newMap.delete(taskId);
      return newMap;
    });
  };

  const clearAll = () => setTasksMap(new Map());

  const value: ResearchTaskContextType = {
    tasksMap,
    getAllTasks,
    getTaskById,
    setTask,
    updateTask,
    deleteTask,
    clearAll,
  };

  return (
    <ResearchTaskContext.Provider value={value}>
      {children}
    </ResearchTaskContext.Provider>
  );
};

export const useResearchTasks = (): ResearchTaskContextType => {
  const ctx = useContext(ResearchTaskContext);
  if (!ctx)
    throw new Error(
      "useResearchTasks must be used within a ResearchTaskProvider",
    );
  return ctx;
};
